export enum DateFormat {
  date = 'MM/DD/YYYY',
  hours = 'h:mmA',
  queryFilterFormat = 'YYYY-MM-DD',
}
